export default {
  SET_USER (state, userData) {
    state.currentUser = userData
  },

  SET_AVATAR(state, avatar) {
    state.currentUser.avatar = avatar;
  }
}
